import React, { useEffect, useState } from "react";
import { fetchProducts } from "../services/api";
import { useCart } from "../context/CartContext";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const { addToCart, cart } = useCart();

  useEffect(() => {
    fetchProducts().then((res) => setProducts(res.data));
  }, []);

  const isInCart = (id) => cart.some((i) => i._id === id);

  return (
    <div style={{ padding: "40px 60px", background: "#f8f9fa", minHeight: "100vh" }}>
      <h1 style={{ fontSize: "2rem", marginBottom: "8px", color: "#1a1a2e" }}>🛍️ Our Products</h1>
      <p style={{ color: "#666", marginBottom: "32px" }}>Top picks just for you</p>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        gap: "24px"
      }}>
        {products.map((p) => (
          <div key={p._id} style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            transition: "transform 0.2s, box-shadow 0.2s",
            display: "flex",
            flexDirection: "column",
            gap: "12px"
          }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)";
            }}
          >
            <div style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "12px",
              height: "140px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "48px"
            }}>
              🖥️
            </div>
            <span style={{
              background: "#f0f4ff",
              color: "#667eea",
              fontSize: "12px",
              padding: "4px 10px",
              borderRadius: "20px",
              width: "fit-content",
              fontWeight: "600"
            }}>{p.category}</span>
            <h3 style={{ margin: 0, fontSize: "1.1rem", color: "#1a1a2e" }}>{p.name}</h3>
            <p style={{ margin: 0, color: "#888", fontSize: "0.9rem" }}>{p.description}</p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "auto" }}>
              <span style={{ fontSize: "1.4rem", fontWeight: "700", color: "#1a1a2e" }}>₹{p.price}</span>
              <span style={{ fontSize: "0.8rem", color: p.stock > 0 ? "#22c55e" : "#ef4444" }}>
                {p.stock > 0 ? `${p.stock} in stock` : "Out of stock"}
              </span>
            </div>
            <button
              onClick={() => addToCart(p)}
              disabled={isInCart(p._id)}
              style={{
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                background: isInCart(p._id)
                  ? "#e2e8f0"
                  : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: isInCart(p._id) ? "#94a3b8" : "#fff",
                fontWeight: "600",
                fontSize: "0.95rem",
                cursor: isInCart(p._id) ? "default" : "pointer",
                transition: "opacity 0.2s"
              }}
            >
              {isInCart(p._id) ? "✓ Added to Cart" : "Add to Cart"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;